<template>
  <div class="form-group required" v-bind:class="{'has-error': hasErrors}">
    <label  v-if="hasLabel" class="control-label" v-bind:for="inputId" v-bind:class="{ 'required': obligatory }">
      <abbr title="required" v-if="obligatory">*</abbr>
      {{label}}
    </label>
    <input
      class="form-control required"
      :id="inputId"
      :type="kind"
      :value="value"
      :name="name"
      :disabled="disabled"
      :placeholder="placeholder" />
    <div class="message" v-if="hasErrors">{{$t('fieldRequired')}}</div>
  </div>
</template>

<script>
export default {
  props:   {
    id: {
      type: String,
      required: false,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type:     String,
      required: false,
      default:  ""
    },
    placeholder: {
      type:     String,
      required: false,
      default:  ""
    },
    value: {
      type:     String,
      required: false
    },
    obligatory: {
      type:     Boolean,
      default:  false
    },
    kind: {
      type: String,
      required: false,
      default: "text"
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      inputId: "",
      messageError: ""
    }
  },
  mounted() {
    let vm = this,
      input = this.$el.querySelector("input");
    this.setId();
    input.onkeyup = function() {
      vm.$emit("input", this.value)
    }
  },
  watch: {
    value(value) { }
  },
  computed: {
    hasErrors() {
      let error = this.errors.items.find(item => {
        return item.field == this.name
      })

      if(error) {
        this.messageError = error.msg
        return true
      } else {
        return false
      }
    },
    message() {
      return (this.hasErrors) ? this.messageError : ""
    },
    hasLabel() {
      return (this.label.length > 0)
    }
  },
  methods: {
    setId() {
      if(this.id == null) {
        this.inputId = new Date().getTime().toString();
      } else {
        this.inputId = this.id;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-group {
  text-align: left;
}
</style>